import spartaEventsUtility from "utilities/global/sparta-events-utility/2.3.2/js/sparta-events-utility";
import _ from "utilities/vendor/lodash/4.13.1/js/lodash.custom.min";
import spartaStoreUtility from "utilities/global/sparta-store-utility/3.0.3/js/sparta-store-utility";
import * as CommonBrowserUtils from "utilities/community/common-browser-utils/1.0.0/js/common-browser-utils";
import spartaMediaQueryConstantsUtility from "utilities/global/sparta-mediaquery-constants-utility/1.1.0/js/sparta-mediaquery-constants-utility";
import TagMapModel from "utilities/global/sparta-mediaquery-utility/2.0.2/js/TagMapModel";
import { getPrefixedPixelRatio } from "utilities/global/sparta-mediaquery-utility/2.0.2/js/utils";
import EVENTS from "utilities/global/sparta-mediaquery-utility/2.0.2/js/events";




const defaultResolutionMediaQueryString = `not screen and (${getPrefixedPixelRatio()}), not screen and (min-resolution: 192dpi), not screen and (min-resolution: 2dppx)`;





const retinaResolutionMediaQueryString = `only screen and (${getPrefixedPixelRatio()}), only screen and (min-resolution: 192dpi), only screen and (min-resolution: 2dppx)`;





const prefixedDefaultResolutionQuery = new spartaMediaQueryConstantsUtility.MediaQueryListModel(
  spartaMediaQueryConstantsUtility.constants.mediaQueryResolutionString,
  spartaMediaQueryConstantsUtility.constants.defaultResolutionName,
  defaultResolutionMediaQueryString,
);





const prefixedRetinaResolutionQuery = new spartaMediaQueryConstantsUtility.MediaQueryListModel(
  spartaMediaQueryConstantsUtility.constants.mediaQueryResolutionString,
  spartaMediaQueryConstantsUtility.constants.retinaResolutionName,
  retinaResolutionMediaQueryString,
);




spartaMediaQueryConstantsUtility.mediaQueriesList.splice(
  spartaMediaQueryConstantsUtility.mediaQueriesList.length - 2, 2,
  prefixedDefaultResolutionQuery,
  prefixedRetinaResolutionQuery,
);






const mediaQueryDefinitions = {





  [`${spartaMediaQueryConstantsUtility.constants.smallViewportName}-${spartaMediaQueryConstantsUtility.constants.mediaQueryUpString}`]: element => element.classList.contains(spartaMediaQueryConstantsUtility.constants.smallViewportName),






  [`${spartaMediaQueryConstantsUtility.constants.smallViewportName}-${spartaMediaQueryConstantsUtility.constants.mediaQueryOnlyString}`]: element => element.classList.contains(spartaMediaQueryConstantsUtility.constants.smallViewportName) && !element.classList.contains(spartaMediaQueryConstantsUtility.constants.mediumViewportName),






  [`${spartaMediaQueryConstantsUtility.constants.mediumViewportName}-${spartaMediaQueryConstantsUtility.constants.mediaQueryUpString}`]: element => element.classList.contains(spartaMediaQueryConstantsUtility.constants.mediumViewportName),






  [`${spartaMediaQueryConstantsUtility.constants.mediumViewportName}-${spartaMediaQueryConstantsUtility.constants.mediaQueryOnlyString}`]: element => element.classList.contains(spartaMediaQueryConstantsUtility.constants.mediumViewportName) && !element.classList.contains(spartaMediaQueryConstantsUtility.constants.largeViewportName),






  [`${spartaMediaQueryConstantsUtility.constants.largeViewportName}-${spartaMediaQueryConstantsUtility.constants.mediaQueryUpString}`]: element => element.classList.contains(spartaMediaQueryConstantsUtility.constants.largeViewportName),






  [`${spartaMediaQueryConstantsUtility.constants.largeViewportName}-${spartaMediaQueryConstantsUtility.constants.mediaQueryOnlyString}`]: element => element.classList.contains(spartaMediaQueryConstantsUtility.constants.largeViewportName) && !element.classList.contains(spartaMediaQueryConstantsUtility.constants.xlargeViewportName),






  [`${spartaMediaQueryConstantsUtility.constants.xlargeViewportName}-${spartaMediaQueryConstantsUtility.constants.mediaQueryUpString}`]: element => element.classList.contains(spartaMediaQueryConstantsUtility.constants.xlargeViewportName),






  [`${spartaMediaQueryConstantsUtility.constants.xlargeViewportName}-${spartaMediaQueryConstantsUtility.constants.mediaQueryOnlyString}`]: element => element.classList.contains(spartaMediaQueryConstantsUtility.constants.xlargeViewportName) && !element.classList.contains(spartaMediaQueryConstantsUtility.constants.xxlargeViewportName),






  [`${spartaMediaQueryConstantsUtility.constants.xxlargeViewportName}-${spartaMediaQueryConstantsUtility.constants.mediaQueryUpString}`]: element => element.classList.contains(spartaMediaQueryConstantsUtility.constants.xxlargeViewportName),






  [`${spartaMediaQueryConstantsUtility.constants.xxlargeViewportName}-${spartaMediaQueryConstantsUtility.constants.mediaQueryOnlyString}`]: element => element.classList.contains(spartaMediaQueryConstantsUtility.constants.xxlargeViewportName),
};








class MediaQueryUtility {






  constructor(container = spartaMediaQueryConstantsUtility.constants.spartaContainerSelector) {

    this.spartaContainerSelector = container;


    this.mediaQueries = spartaMediaQueryConstantsUtility.mediaQueriesList;


    this.viewportNames = spartaMediaQueryConstantsUtility.constants.viewportNames;


    this.isWidget = false;


    this.isAndroid = false;



    this.useLargeAsLargeUp = true;


    this.matchedQuery = {};
  }






  get EVENTS() {
    return EVENTS;
  }







  init(appRootEl) {

    if (appRootEl && appRootEl.nodeType) {
      this.appRootEl = appRootEl;
    } else {

      this.appRootEl = document.querySelector(appRootEl)
        || document.querySelector(this.spartaContainerSelector);
    }


    this.isWidget = this.appRootEl
      .hasAttribute(spartaMediaQueryConstantsUtility.constants.spartaWidgetContainerString);


    this.isAndroid = CommonBrowserUtils.isAndroid();


    this.setupWindowResizeEvents();


    this.removeLoadingClass();
  }






  removeLoadingClass() {
    this.appRootEl.classList.remove(spartaMediaQueryConstantsUtility.constants.utilityLoadingClass);
  }






  setupWindowResizeEvents() {

    if (!this.isWidget) {

      if (this.isAndroid) {

        this.prevDimensions = this.originalDimensions || { width: 0, height: 0 };
        this.originalDimensions = { width: window.innerWidth, height: window.innerHeight };

        window.addEventListener('orientationchange', () => {
          const afterOrientationChange = function afterOrientationChange() {
            if (
              this.originalDimensions.width !== window.innerWidth
              || this.originalDimensions.height !== window.innerHeight
            ) {
              this.prevDimensions = this.originalDimensions;
              this.originalDimensions = { width: window.innerWidth, height: window.innerHeight };
            }
            window.removeEventListener('resize', afterOrientationChange);
          };
          window.addEventListener('resize', afterOrientationChange.bind(this));
        });
      }

      this.mediaQueries.forEach(({ name, type, mediaQuery }) => {
        const mql = window.matchMedia(mediaQuery);

        if (this.isAndroid) { 
          mql.addListener(() => setTimeout(() => {
            this.handleResize(name, type, mql);
          }, 0));
        } else {
          mql.addListener(this.handleResize.bind(this, name, type));
        }

        this.handleResize(name, type, mql, true);
      });

      spartaEventsUtility.pub(this.EVENTS.BREAKPOINT_CHANGE, this.matchedQuery);
    } else {

      window.onresize = _.bind(_.debounce(
        this.respondToContainerSize,
        spartaMediaQueryConstantsUtility.constants.spartaWidgetResizeDebounceDelay,
      ), this);


      this.respondToContainerSize();


      spartaEventsUtility.sub(this.EVENTS.WIDGET_RESIZE, this.respondToContainerSize.bind(this));
    }
  }











  handleResize(mqName, mqType, mqlList, initial = false) {
    if (mqlList.matches) {

      this.matchedQuery[mqType] = mqName;

      this.appRootEl.classList.add(mqName);
    } else {
      this.appRootEl.classList.remove(mqName);
    }


    const suppress = (
      this.isAndroid
      && this.originalDimensions.width === window.innerWidth
      && this.originalDimensions.height >= window.innerHeight
      && this.originalDimensions.width !== this.prevDimensions.height
    );

    this.afterResize(suppress || initial);
  }






  respondToContainerSize() {
    const dimensions = this.appRootEl.getBoundingClientRect();

    this.mediaQueries.forEach(({
      name, type, width, mediaQuery,
    }) => {
      switch (type) {
        case spartaMediaQueryConstantsUtility.constants.mediaQueryViewportString:
          if (dimensions.width >= width) {
            this.appRootEl.classList.add(name);


            this.matchedQuery[type] = name;
          } else {
            this.appRootEl.classList.remove(name);
          }

          break;

        case spartaMediaQueryConstantsUtility.constants.mediaQueryResolutionString:
          if (window.matchMedia(mediaQuery).matches) {
            this.appRootEl.classList.add(name);


            this.matchedQuery[type] = name;
          } else {
            this.appRootEl.classList.remove(name);
          }

          break;

        case spartaMediaQueryConstantsUtility.constants.mediaQueryOrientationString:
          if (name === spartaMediaQueryConstantsUtility.constants.portraitOrientationName) {
            if (dimensions.height > dimensions.width) {
              this.appRootEl.classList.add(name);


              this.matchedQuery[type] = name;
            } else {
              this.appRootEl.classList.remove(name);
            }
          } else if (name === spartaMediaQueryConstantsUtility.constants.landscapeOrientationName) {
            if (dimensions.width > dimensions.height) {
              this.appRootEl.classList.add(name);


              this.matchedQuery[type] = name;
            } else {
              this.appRootEl.classList.remove(name);
            }
          }

          break;

        default:
          break;
      }
    });

    this.afterResize();
  }







  afterResize(suppressEvent = false) {

    const {
      currentViewport, currentResolution, currentOrientation, mediaQueryInfo,
    } = this.getCurrentViewport();

    Object.keys(mediaQueryInfo).forEach((item) => {
      if (mediaQueryInfo[item]) {
        this.appRootEl.classList.add(item);
      } else {
        this.appRootEl.classList.remove(item);
      }
    });


    const storeObject = {
      [spartaMediaQueryConstantsUtility.constants.mediaQueryViewportString]: currentViewport,
      [spartaMediaQueryConstantsUtility.constants.mediaQueryResolutionString]: currentResolution,
      [spartaMediaQueryConstantsUtility.constants.mediaQueryOrientationString]: currentOrientation,
      [spartaMediaQueryConstantsUtility.constants.spartaStoreMediaQueriesKey]: mediaQueryInfo,
    };


    spartaStoreUtility.updateData(`${spartaMediaQueryConstantsUtility.constants.spartaStoreNamespace}`, storeObject);


    if (!this.isWidget) {

      this.setViewportMetaTags(currentViewport);
    }


    if (!suppressEvent) {

      spartaEventsUtility.pub(this.EVENTS.BREAKPOINT_CHANGE, storeObject);
    }
  }






  getCurrentViewport() {
    let currentViewport = spartaMediaQueryConstantsUtility.constants.smallViewportName;
    let currentResolution = spartaMediaQueryConstantsUtility.constants.defaultResolutionName;
    let currentOrientation = spartaMediaQueryConstantsUtility.constants.portraitOrientationName;

    const mediaQueryInfo = {};

    this.mediaQueries.forEach(({ type, name }) => {


      if (name === spartaMediaQueryConstantsUtility.constants.smallViewportName) {
        mediaQueryInfo[name] = true;
      } else {
        mediaQueryInfo[name] = this.appRootEl.classList.contains(name);
      }

      switch (type) {
        case spartaMediaQueryConstantsUtility.constants.mediaQueryViewportString:
          if (this.appRootEl.classList.contains(name)) {
            currentViewport = name;
          }

          break;

        case spartaMediaQueryConstantsUtility.constants.mediaQueryOrientationString:
          if (this.appRootEl.classList.contains(name)) {
            currentOrientation = name;
          }

          break;

        case spartaMediaQueryConstantsUtility.constants.mediaQueryResolutionString:
          if (this.appRootEl.classList.contains(name)) {
            currentResolution = name;
          }

          break;

        default:
          break;
      }
    });


    Object.keys(mediaQueryDefinitions).forEach((query) => {

      mediaQueryInfo[query] = mediaQueryDefinitions[query](this.appRootEl);
    });


    return {
      currentViewport, currentResolution, currentOrientation, mediaQueryInfo,
    };
  }







  setViewportMetaTags(currentViewport = 'default') {

    if (this.isWidget) {
      return false;
    }


    if (typeof window.sparta.metaTags === 'undefined') {
      return false;
    }





    const propertyTypeString = 'property';





    const attributeTypeString = 'attribute';





    const defaultMetaTagString = 'default';












    const tagMap = [
      new TagMapModel('title', 'title', 'innerHTML', propertyTypeString),
      new TagMapModel('link', 'canonical', 'href', attributeTypeString, 'rel'),
      new TagMapModel('meta', 'keywords', 'content', attributeTypeString, 'name'),
      new TagMapModel('meta', 'description', 'content', attributeTypeString, 'name'),
      new TagMapModel('meta', 'og:title', 'content', attributeTypeString, 'property'),
      new TagMapModel('meta', 'og:type', 'content', attributeTypeString, 'property'),
      new TagMapModel('meta', 'og:image', 'content', attributeTypeString, 'property'),
      new TagMapModel('meta', 'og:description', 'content', attributeTypeString, 'property'),
      new TagMapModel('meta', 'og:url', 'content', attributeTypeString, 'property'),
      new TagMapModel('meta', 'og:site_name', 'content', attributeTypeString, 'property'),
    ];


    tagMap.forEach(({
      tag, attr, val, set, type,
    }) => {

      let value = window.sparta.metaTags[val];


      if (typeof value === 'undefined') {
        return false;
      }


      if (Object.prototype.hasOwnProperty.call(value, currentViewport)) {

        value = value[currentViewport];
      } else if (typeof value !== 'string') { 


        if (this.useLargeAsLargeUp
          && value[spartaMediaQueryConstantsUtility.constants.viewportNames.large]
          && (currentViewport === spartaMediaQueryConstantsUtility.constants.viewportNames.xlarge
            || currentViewport === spartaMediaQueryConstantsUtility.constants.viewportNames.xxlarge)
        ) {
          value = value[spartaMediaQueryConstantsUtility.constants.viewportNames.large];
        } else {
          value = value[defaultMetaTagString];
        }
      }



      const selector = `${tag}${(attr) ? `[${attr}${(val) ? `="${val}"` : ''}]` : ''}`;


      const tagElement = document.querySelector(selector);


      if (tagElement) {

        if (type === attributeTypeString) {
          tagElement.setAttribute(set, value);
        } else if (type === propertyTypeString) {
          tagElement[set] = value;
        }
      } else {

        const generatedTag = document.createElement(tag);

        if (type === attributeTypeString) {
          generatedTag.setAttribute(set, value);
          generatedTag.setAttribute(attr, val);
        } else if (type === propertyTypeString) {
          generatedTag[set] = value;
        }


        document.head.append(generatedTag);
      }
      return true;
    });
    return true;
  }
}





const mediaQueryUtility = new MediaQueryUtility();


export default mediaQueryUtility;
